import { ApiInventoryLevel, ApiInventoryLevelLegacy } from '@vend/types'
import { fetchApi } from '@vend/utilities'

interface InventoryOptions {
  include_variants?: boolean
  location_ids?: string[]
}

/**
 * @deprecated use getInventory instead.
 *
 * Get inventory information for the products identified by the given product IDs.
 *
 * @param  productIds
 *         The IDs of the products to get inventory levels for
 *
 * @param  options
 *
 *         @param options.include_variants
 *         Whether to fetch inventory information for all variants of the given parent products
 *
 *         @param options.location_ids
 *         The IDs of outlets to fetch inventory information for (if omitted will be all outlets)
 *
 * @return A promise resolved with the array of inventory information for the
 *         given products
 */
export const getInventoryLegacy = async (
  productIds: string[],
  options?: InventoryOptions
): Promise<ApiInventoryLevelLegacy[]> => {
  const optionsObject = {
    ...options,
    include_composites: true,
    product_ids: productIds,
    size: 1000,
  }
  const optionsString = JSON.stringify(optionsObject)

  const response = await fetchApi(
    `/api/2.0/inventory_levels?options=${optionsString}`,
    {
      method: 'GET',
    }
  )

  if (!response.ok) {
    throw new Error('Failed to get inventory levels')
  }

  const json = await response.json()

  return json.data
}

/**
 * Get inventory information for the products identified by the given product IDs.
 *
 * @param  productIds
 *         The IDs of the products to get inventory levels for
 *
 * @param  options
 *
 *         @param options.include_variants
 *         Whether to fetch inventory information for all variants of the given parent products
 *
 *         @param options.location_ids
 *         The IDs of outlets to fetch inventory information for (if omitted will be all outlets)
 *
 * @return A promise resolved with the array of inventory information for the
 *         given products
 */
export const getInventory = async (
  productIds: string[],
  options?: InventoryOptions
): Promise<ApiInventoryLevel[]> => {
  const body: Record<string, any> = {
    include_composites: true,
    product_ids: productIds,
    size: 1000,
  }
  if (options) {
    if (options.location_ids && options?.location_ids.length > 0) {
      body.location_ids = options.location_ids
    }
    if (options.include_variants === true) {
      body.root_product_ids = productIds
    } else {
      body.product_ids = productIds
    }
  }

  const response = await fetchApi(`/api/2026-04/inventory_levels`, {
    method: 'POST',
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    throw new Error('Failed to get inventory levels')
  }

  return await response.json()
}
